import React from 'react';
import { ComplexRoute } from 'router/components/Routes/Routes';
import { Navigate } from 'react-router-dom';
import Managers from './pages/Managers';
import Admins from './pages/Admins';

export default [
  {
    label: 'managers',
    path: 'managers',
    element: Managers,
  },
  {
    label: 'admins',
    path: 'admins',
    element: Admins,
  },
  {
    index: true,
    element: <Navigate to="managers" />,
  },
] as Array<ComplexRoute>;
